import service from './request'
import uploadService from "./uploadRequest.js";

/**
 * 获取邮件接收列表
 */
export const getEmailList = data => {
    return service({
        showLoading: true,
        url: '/platform/email/receive/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取邮件接收信息详情
 */
export const getEmailInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/receive/getInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 邮件接收信息跟进处理
 */
export const receiveUpdateInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/receive/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 接收邮件跟进信息列表
 */
export const getFollowRec = data => {
    return service({
        showLoading: true,
        url: '/platform/email/receive/getFollowRec',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 接收邮件跟进信息列表-查看
 */
export const getInfoByFollowRecId = data => {
    return service({
        showLoading: true,
        url: '/platform/email/send/getInfoByFollowRecId',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取邮件发送列表
 */
export const getEmailSendList = data => {
    return service({
        showLoading: true,
        url: '/platform/email/send/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 邮件发送信息修改
 */
export const sendUpdateInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/send/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取邮件发送信息详情。
 */
export const sendGetInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/send/getInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取邮件服务配置列表
 */
export const getEmailSerCfgList = data => {
    return service({
        showLoading: true,
        url: '/platform/email/serCfg/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 邮件服务配置信息添加
 */
export const addEmailSerCfg = data => {
    return service({
        showLoading: true,
        url: '/platform/email/serCfg/addInfo',
        method: 'post',
        type: 'body',
        timeout: 10000,
        data
    })
}

/**
 * 邮件服务配置信息添加
 */
export const updateEmailSerCfg = data => {
    return service({
        showLoading: true,
        url: '/platform/email/serCfg/updateInfo',
        method: 'post',
        type: 'body',
        timeout: 10000,
        data
    })
}

/**
 * 邮件服务配置信息查看
 */
export const getEmailSerCfgInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/serCfg/getInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 邮件服务配置信息删除
 */
export const deleteEmailSerCfg = data => {
    return service({
        showLoading: true,
        url: '/platform/email/serCfg/delInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取邮件模板信息列表
 */
export const templategetList = data => {
    return service({
        showLoading: true,
        url: '/platform/email/template/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
* 获取邮件模板树状信息列表
*/
export const templateTreeList = data => {
    return service({
        showLoading: true,
        url: '/platform/email/template/getTreeList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
* 对邮件模板信息进行添加处理
*/
export const templateAddInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/template/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
* 主要用邮件模板信息的修改处理
*/
export const templateUpdateInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/template/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
* 主要用邮件模板信息的删除处理
*/
export const templateDelInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/template/delInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 对邮件类型信息进行添加处理
 */
export const emailTypeAddinfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/type/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 主要用邮件类型信息的修改处理
 */
export const emailTypeUpdateInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/type/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 主要用邮件类型信息的删除处理
 */
export const emailTypeDelInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/type/delInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 邮件服务人员配置信息添加
 */
export const ser2PersonCfgAddInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/ser2PersonCfg/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取邮件服务与人员对应关系配置信息列表
 */
export const ser2PersonCfgGetList = data => {
    return service({
        showLoading: true,
        url: '/platform/email/ser2PersonCfg/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 邮件服务人员配置信息批量添加
 */
export const ser2PersonCfgAddBatchInfo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/ser2PersonCfg/addBatchInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取邮箱列表数据
 */
export const baseDataEmailList = data => {
    return service({
        showLoading: true,
        url: '/platform/baseData/getEmailList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取发件人列表
 */
export const getSendEmailAccountList = data => {
    return service({
        showLoading: true,
        url: '/platform/email/send/getSendEmailAccountList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 上传发送邮件附件
 */
export const uploadEmailFile = data => {
    return uploadService({
        showLoading: true,
        url: '/platform/email/send/uploadEmailFile',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 删除发送邮件附件
 */
export const delEmailFile = data => {
    return service({
        showLoading: true,
        url: '/platform/email/send/delEmailFile',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 邮件发送信息添加
 */
export const emailSendIndo = data => {
    return service({
        showLoading: true,
        url: '/platform/email/send/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取会话的标签信息
 */
export const getSessionLableList = data => {
    return service({
        showLoading: false,
        url: '/platform/sessionLable/cfg/getTree',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取邮件类型列表信息
 */
export const getEmailTypeList = data => {
    return service({
        showLoading: true,
        url: '/platform/email/type/getList',
        method: 'post',
        type: 'body',
        data
    })
}

//会话标签标识
export const saveData = data => {
  return service({
    url: "/platform/sessionLable/cfg/saveData",
    method: "post",
    type: 'body',
    data
  });
};


// WEBPACK FOOTER //
// ./src/http/EmailManagement.js